/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReceiptPositionDto
 */
export interface GetReceiptPositionDto {
    /**
     * 
     * @type {string}
     * @memberof GetReceiptPositionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptPositionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptPositionDto
     */
    amount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetReceiptPositionDto
     */
    vat: GetReceiptPositionDtoVatEnum;
    /**
     * 
     * @type {number}
     * @memberof GetReceiptPositionDto
     */
    order?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetReceiptPositionDto
     */
    quantity?: number | null;
}


/**
 * @export
 */
export const GetReceiptPositionDtoVatEnum = {
    _23: '23%',
    _8: '8%',
    _5: '5%',
    _0_KR: '0% KR',
    zw: 'zw.'
} as const;
export type GetReceiptPositionDtoVatEnum = typeof GetReceiptPositionDtoVatEnum[keyof typeof GetReceiptPositionDtoVatEnum];


/**
 * Check if a given object implements the GetReceiptPositionDto interface.
 */
export function instanceOfGetReceiptPositionDto(value: object): value is GetReceiptPositionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('vat' in value) || value['vat'] === undefined) return false;
    return true;
}

export function GetReceiptPositionDtoFromJSON(json: any): GetReceiptPositionDto {
    return GetReceiptPositionDtoFromJSONTyped(json, false);
}

export function GetReceiptPositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReceiptPositionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'vat': json['vat'],
        'order': json['order'] == null ? undefined : json['order'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function GetReceiptPositionDtoToJSON(value?: GetReceiptPositionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'amount': value['amount'],
        'vat': value['vat'],
        'order': value['order'],
        'quantity': value['quantity'],
    };
}

